import {Route, Routes, Outlet, Navigate} from 'react-router-dom'
import {PageLink, PageTitle} from '../../../../_metronic/layout/core'
import { KycDataListWrapper } from './list/KycDataList'
import { UsersListWrapper } from './list/BusinessKycList'

const businessBreadcrumbs: Array<PageLink> = [
    {
        title: 'KYB Verifications',
        path: '/kyb/overview',
        isSeparator: false,
        isActive: true,
    },
    {
        title: 'Company',
        path: '/kyb/',
        isSeparator: true,
        isActive: false,
    },
]

const BusinessPage = () => {
    return (
        <Routes>
            <Route element={<Outlet/>}>
                <Route
                    path='overview'
                    element={
                        <>
                            <PageTitle breadcrumbs={businessBreadcrumbs}>KYB Verifications</PageTitle>
                            <UsersListWrapper/>
                        </>
                    }
                />
                <Route
                    path='data'
                    element={
                        <>
                            <PageTitle breadcrumbs={businessBreadcrumbs}>KYB Verifications</PageTitle>
                            <KycDataListWrapper/>
                        </>
                    }
                />
            </Route>
            <Route index element={<Navigate to='/kyb/overview'/>}/>
        </Routes>
    )
}

export default BusinessPage
